module.exports = __webpack_public_path__ + "media/audio42.d1b8468d.mp3";